import { render, staticRenderFns } from "./ExportRatingsPDF.vue?vue&type=template&id=bf63b4ee&scoped=true"
import script from "./ExportRatingsPDF.vue?vue&type=script&lang=js"
export * from "./ExportRatingsPDF.vue?vue&type=script&lang=js"
import style0 from "./ExportRatingsPDF.vue?vue&type=style&index=0&id=bf63b4ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf63b4ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf63b4ee')) {
      api.createRecord('bf63b4ee', component.options)
    } else {
      api.reload('bf63b4ee', component.options)
    }
    module.hot.accept("./ExportRatingsPDF.vue?vue&type=template&id=bf63b4ee&scoped=true", function () {
      api.rerender('bf63b4ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/ExportRatingsPDF.vue"
export default component.exports